module.exports = __webpack_public_path__ + "static/media/Step 9-Email_Drawings_&_Reports.9d6f7499.gif";


//////////////////
// WEBPACK FOOTER
// ./src/media/tutorial-images/Step 9-Email_Drawings_&_Reports.gif
// module id = 3049
// module chunks = 0